import React, { memo, useCallback, useMemo, useState } from 'react';
import * as R from 'ramda';

import { VegaLiteSpec } from '@atom/types/conversationalAnalytics';

import ConversationalAnalyticsChart from '../conversationalAnalytics/ConversationalAnalyticsChart';

import { useIsAssistantMessageLoading } from './hooks/useIsAssitantMessageLoading';
import ChatExportChart from './ChatExportChart';

export type ChatConversationalAnalyticsToolProps = {
  result?: {
    chart?: {
      vegaConfig?: VegaLiteSpec;
    };
  };
};

const ChatConversationalAnalyticsTool: React.FC<
  ChatConversationalAnalyticsToolProps
> = props => {
  const spec = props?.result?.chart?.vegaConfig;
  const isLoading = useIsAssistantMessageLoading();
  const [exportOpen, setExportOpen] = useState(false);

  const handleOpen = useCallback(() => setExportOpen(true), []);
  const handleClose = useCallback(() => setExportOpen(false), []);

  // memoize the chart to prevent re-renders during streaming
  const chart = useMemo(() => {
    if (!spec) {
      return null;
    }
    return <ConversationalAnalyticsChart spec={spec} onExport={handleOpen} />;
  }, [spec, handleOpen]);

  if (isLoading || !spec) {
    return null;
  }

  return (
    <>
      {chart}
      <ChatExportChart spec={spec} open={exportOpen} onClose={handleClose} />
    </>
  );
};

// memoize the spec to prevent re-renders when other messages stream
export default memo(ChatConversationalAnalyticsTool, (prev, next) => {
  return R.equals(
    prev?.result?.chart?.vegaConfig,
    next?.result?.chart?.vegaConfig,
  );
});
